import { createSlice } from '@reduxjs/toolkit';
import { IPossibleAppointmentItemSchema } from 'shared/repositories/announcements/entities/v1_get_possible_appointments/PossibleAppointmentItemSchema';

const initialState: IPossibleAppointmentItemSchema[] = [];

export const specialtyTypeOptionsSlice = createSlice({
  name: 'specialtyTypeOptions',
  initialState,
  reducers: {},
});

export const { reducer: specialtyTypeOptionsReducer, name: specialtyTypeOptionsReducerName } =
  specialtyTypeOptionsSlice;
